import { ChangeEvent, DataHeader, DropdownItem, LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { CompanySettings, StringUtil } from "@mcleod/core";
import { AutogenLayoutInvoiceProcessingProfile } from "./autogen/AutogenLayoutInvoiceProcessingProfile";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch/src/DuplicateId";
import { ModelArControl } from "./models/ModelArControl";

const viewInvoiceProcessingProfileURL = "lme/ar/InvoiceProcessingProfile?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "invoice_processing_profile",
    screenName: "Invoice Processing Profile",
    navigateToUrl: viewInvoiceProcessingProfileURL
}
export class InvoiceProcessingProfile extends AutogenLayoutInvoiceProcessingProfile {
    private BILL_STATUS_ITEMS = [
        new DropdownItem("R", "Ready to Process"),
        new DropdownItem("N", "Not Ready to Process"),
        new DropdownItem("B", "Both")
    ];

    private RATE_SOURCE_ITEMS = [
        new DropdownItem("C", "Contract"),
        new DropdownItem("S", "Spot")
    ];

    private BILL_TYPE_ITEMS = [
        new DropdownItem("I", "Invoice"),
        new DropdownItem("C", "Credit"),
        new DropdownItem("D", "Debit"),
        new DropdownItem("A", "All but Summary"),
        new DropdownItem("S", "Summary"),
    ]

    private orderRespCodesBeforeLookupModelSearchListener: (event: LookupModelSearchEvent) => void;

    override async onLoad() {
        this.layoutProfileColor.profileDataSource = this.mainDataSource;

        this.textboxBillStatus.items = this.BILL_STATUS_ITEMS;
        this.textboxRateOrigin.items = this.RATE_SOURCE_ITEMS;
        this.textboxBillType.items = this.BILL_TYPE_ITEMS;
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);

        this.textboxOrderResponsibilityLevel.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            this.clearResponsibilityCodes();
            this.removeBeforeLookupModelSearchListenerToResponsibilityCodes();
            this.createBeforeLookupListenerForResponsibilityCodes();
            this.mainDataSource.displayDataInBoundComponent(this.textboxResponsibilityCodes);
        });

        this.onResponsibilityLevelChange();
        const companySettings = CompanySettings.get();
        const isAsset = companySettings?.is_asset;
        const isBrokerage = companySettings?.is_brokerage;
        const isBothCompany = isAsset && isBrokerage;
        this.textboxMovementType.visible = isBothCompany;
        this.checkboxMovementTypeExclude.visible = isBothCompany;

        const arControl = await new ModelArControl().searchSingle({}, "lme/ar/ARControl");
        if (arControl) {
            this.switchEnableTransfer.visible = arControl.get("transfer_to_settlement") === "Y";
        }
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    textboxPayeeIdsBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter["drs_payee.type_of"] = "in A"
        event.filter.has_type_of = true;
    }

    textboxSegAllocCodeBeforeLookupModelSearch(event) {
        event.filter.alloc_type = 'M';
        event.filter.is_active = 'Y';
    }

    async sourceInvoiceProcessingProfileAfterExecution(event) {
        this.checkSegAllocEnabled();
    }

    private checkSegAllocEnabled() {
        const allocationEnbabled = this.sourceInvoiceProcessingProfile.activeRow?.get("seg_alloc_enabled");
        delete this.sourceInvoiceProcessingProfile.activeRow?.data["seg_alloc_enabled"];
        this.textboxOrderAllocations.visible = allocationEnbabled;
        this.checkboxOrderAllocationExclude.visible = allocationEnbabled;
    }

    private clearResponsibilityCodes(): void {
        this.textboxResponsibilityCodes.clear();
        this.activeRow?.set("order_resp_codes", null);
    }

    private removeBeforeLookupModelSearchListenerToResponsibilityCodes(): void {
        if (this.orderRespCodesBeforeLookupModelSearchListener) {
            this.textboxResponsibilityCodes.removeBeforeLookupModelSearchListener(this.orderRespCodesBeforeLookupModelSearchListener);
        }
    }

    private createBeforeLookupListenerForResponsibilityCodes() {
        this.orderRespCodesBeforeLookupModelSearchListener = (event) => {
            if (this.activeRow?.isNull("order_resp_level")) {
                event.stop();
                return;
            }
            event.filter.hierarchy_level = this.activeRow?.getNumber("order_resp_level");
        };
        this.textboxResponsibilityCodes.addBeforeLookupModelSearchListener(this.orderRespCodesBeforeLookupModelSearchListener);
    }

    private onResponsibilityLevelChange() {
        this.textboxOrderResponsibilityLevel.addChangeListener((event: ChangeEvent) => {
            const valueResponsibilityLevel = StringUtil.isEmptyString(event.newValue);
            if (valueResponsibilityLevel) {
                this.clearResponsibilityCodes();
                this.mainDataSource.displayDataInBoundComponent(this.textboxResponsibilityCodes);
            }
        });
    }
}
